import { envVars } from '@/envVars';

const redirect = (url: string): void => {
  window.location.assign(url);
};

const redirectToLeadFormAuto = (intendedCredit: string): void => {
  redirect(`${envVars.URL_LEAD_FORM_AUTO}?valor-emprestimo=${intendedCredit}`);
};

const redirectToLeadFormHome = (intendedCredit: string): void => {
  redirect(`${envVars.URL_LEAD_FORM_HOME}?valor-emprestimo=${intendedCredit}`);
};

const redirectToLeadReviewAuto = (): void => {
  redirect(envVars.URL_LEAD_REVIEW_AUTO);
};

const redirectToLeadReviewHome = (): void => {
  redirect(envVars.URL_LEAD_REVIEW_HOME);
};

const redirectToLogin = (): void => {
  redirect(envVars.URL_LOGIN);
};

export {
  redirect,
  redirectToLeadFormAuto,
  redirectToLeadFormHome,
  redirectToLeadReviewAuto,
  redirectToLogin,
  redirectToLeadReviewHome,
};
